// extracted by mini-css-extract-plugin
export default {"downloadBtn":"zUNiOQcS","downBtnIcon":"dXVdghjU"};